(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["sm-home"] && !Shopify.designMode) return;
  try {
    
(function(){
  var root=document.querySelector('.sm-home'); if(!root) return;
  root.classList.add('sm-js');
  root.querySelectorAll('[data-carousel]').forEach(function(car){
    var track=car.querySelector('.carousel__track');
    var slides=[].slice.call(car.querySelectorAll('.carousel__slide'));
    var dotsWrap=car.querySelector('.carousel__dots');
    var i=0;
    var dots=slides.map(function(_,n){var b=document.createElement('button');b.type='button';b.className='carousel__dot';b.setAttribute('aria-label','Go to slide '+(n+1));b.addEventListener('click',function(){go(n);});dotsWrap.appendChild(b);return b;});
    function go(n){i=(n+slides.length)%slides.length;track.style.transform='translateX('+(-i*100)+'%)';dots.forEach(function(d,k){d.setAttribute('aria-current',k===i);});slides.forEach(function(s,k){s.setAttribute('aria-hidden',k!==i);});}
    var p=car.querySelector('.carousel__prev'),nx=car.querySelector('.carousel__next');
    if(p)p.addEventListener('click',function(){go(i-1);});
    if(nx)nx.addEventListener('click',function(){go(i+1);});
    car.addEventListener('keydown',function(e){if(e.key==='ArrowLeft')go(i-1);if(e.key==='ArrowRight')go(i+1);});
    go(0);
  });
  var io=new IntersectionObserver(function(entries){entries.forEach(function(e){if(e.isIntersecting){e.target.classList.add('is-in');io.unobserve(e.target);}});},{rootMargin:'0px 0px -8% 0px'});
  root.querySelectorAll('.reveal').forEach(function(el){io.observe(el);});
})();

  } catch(e) { console.error(e); }
})();
})();
